import { Navigate, useParams } from 'react-router-dom'

/** An athlete's address on its own opens their Today page. */
export default function AthleteHome() {
  const { slug } = useParams()
  return <Navigate to={`/a/${slug}/today`} replace />
}
